import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {Type} from "../../../infrastructure/type";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {APP} from "../../app/consts";

export class BracketsClickEvent extends ClickEvent {
  entityType: Type<EntityViewModel>;
  entityId: Number;
  source: APP.ANALYTICS.SOURCES;
  sportTypeId: Number;

  constructor(params) {
    super('', 'click', 'brackets');

    this.entityType = params.entityType;
    this.entityId = params.entityId;
    this.source = params.source;
    this.sportTypeId = params.sportTypeId;
  }

  get properties() {
    const properties = super.properties;

    properties.entityType = this.entityType;
    properties.entityId = this.entityId;
    properties.source = this.source;
    properties.sportTypeId = this.sportTypeId;

    return properties;
  }
}
